//import { useTranslation } from "react-i18next";
import { ActiveUsersChart } from "./ActiveUsersChart";
import { useAddRemoveWizards } from "../../../hooks/dashboard/useAddRemoveWizard";
import { Row } from "melco-ui";

export const Charts: React.FC<any> = ({ startTimeStamp, endTimeStamp, selectedProductCode }) => {
    //  const { t } = useTranslation();
    const { wizards } = useAddRemoveWizards();
    return (
        <>
            <Row>
                {
                    wizards?.some((obj) => obj.code === "ACTIVE_USERS") &&
                    <ActiveUsersChart
                        startTimestamp={startTimeStamp}
                        endTimestamp={endTimeStamp}
                        selectedProductCode={selectedProductCode}
                    />
                }



            </Row>

        </>);
};
